import React from 'react';
import { NavLink } from 'react-router-dom';
import classes from './NavigationItem.module.css';
// import { FontAwesomeIcon  } from '@fortawesome/react-fontawesome';

const navigationItem = (props) => {
    // console.log('NAVIGATIONITEM', props)
    let attachClasses = [classes.NavigationItem];

    if (props.alignLeft) {
        attachClasses = [classes.NavigationItem, classes.AlignLeft, classes.OpenSubMenu];
    }

    if (props.footer) {
        attachClasses = [classes.NavigationItem, classes.AlignLeft, classes.OpenSubMenu, classes.FooterLink];
    }

    return (
        <li className={attachClasses.join(' ')}>
            <NavLink exact to={props.link} onClick={props.toOpen} activeClassName={classes.active}>
                {props.children}
            </NavLink>
        </li>
    )
};

export default navigationItem;